/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { CommonTable } from '../../../../component/common/table2/CommonTable';
import Pagination from '../../../../component/common/table2/Pagination';
import { pageOptions } from '../../../../utils/dropDownConfig';
import FormSelect from '../../../../component/common/FormSelect';
import { FunnelIcon, PencilSquareIcon, InboxArrowDownIcon } from '@heroicons/react/24/outline';
import FilterModal from './FilterModal';
import { Api } from '../../../../api';
import {
  errorToast,
  formatAmount,
  formatAmountWithCurrency,
  getPaymentStatus,
  successToast,
  uploadImage
} from '../../../../utils/helper';
import Loader from '../../../../component/common/Loader';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import CommonPopover from '../../../../component/common/popover';
// import ViewReasonPopup from "./ViewReasonPopup";
import filterIcon from '../../../../assets/images/filter-icon.svg';
import FilterSummary from '../../../../component/common/TableFilter/FilterSummary';
import ApprovePaymentPopup from './ApprovePaymentPopup';
import InvoiceStatCard from '../../../../component/Peap/InvoiceCard';
import { Button } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { SpecialistPageData } from '../../../../utils/pageContent';

function Payment() {
  const theme = localStorage.getItem('selectedTheme');
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [paymentList, setPaymentList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterQuery, setFilterQuery] = useState('');
  const [filterCriteria, setFilterCriteria] = useState({});
  const [filterSummaryData, setFilterSummaryData] = useState({});
  const [manageRequestData, setManageRequestData] = useState({});
  const [openViewReasonPopup, setOpenViewReasonPopup] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingAmount, setEditingAmount] = useState({});
  const [originalAmounts, setOriginalAmounts] = useState({});
  const [isFilterApply, setIsFilterApply] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [expertOptions, setExpertOptions] = useState([]);
  const [selectedExperts, setSelectedExperts] = useState([]);
  const [openPaymentApproveModal, setOpenPaymentApproveModal] = useState(false);
  const [payload, setPayload] = useState({});
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

  const [totalInvoicesCount, setTotalInvoicesCount] = useState(0);
  const [totalPaidInvoicesCount, setTotalPaidInvoicesCount] = useState(0);
  const [totalUnpaidInvoicesCount, setTotalUnpaidInvoicesCount] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);

  const inputRef = useRef({});
  const [selectedTab, setSelectedTab] = useState('All');
  const [selectedStatus, setSelectedStatus] = useState(null);
  const pageData = SpecialistPageData.paymentTabData;

  /* HANDLE PER PAGE */
  const handlePerPage = (_, value) => {
    setRecordsPerPage(Number(value));
    setCurrentPage(1);
  };

  /* HANDLE PAGINATION */
  const handlePagination = async (pageNumber, pageSize, query, status) => {
    setLoader(true);
    const response = await Api.getTransactionData(pageNumber, pageSize, query, status);

    if (response?.data?.meta?.code === 1) {
      setCurrentPage(pageNumber);
      setPaymentList(response?.data?.data);
      setTotalCount(response?.data?.meta?.totalCount);

      setTotalInvoicesCount(response?.data?.meta?.totalInvoices);
      setTotalPaidInvoicesCount(response?.data?.meta?.paidInvoices);
      setTotalUnpaidInvoicesCount(response?.data?.meta?.unpaidInvoices);
      setTotalAmountPaid(response?.data?.meta?.paidAmount);
      setLoader(false);
    } else if (response?.code === 401) {
      setLoader(false);
      errorToast(response?.message);
    } else if (response?.data?.meta?.code === 0) {
      setCurrentPage(1);
      setPaymentList([]);
      setTotalCount(0);
      setLoader(false);
      errorToast(response?.data?.meta?.message);
    } else {
      setLoader(false);
    }
  };

  /* HANDLE FILTER */
  const handleFilter = () => {
    setShowFilterModal((state) => !state);
  };

  /* MAP PAYMENT STATUS TO STRING */
  const mapPaymentStatusToString = (status) => {
    if (status === 1) return pageData.paymentStatusStrings.paid;
    if (status === 2) return pageData.paymentStatusStrings.unPaid;
    return ''; // Return empty if no status is found
  };

  /* FILTER HANDLER */
  const filterHandler = useCallback(() => {
    let newData = { ...filterCriteria };

    // Initialize a filter summary object
    let summaryData = {};
    // Map each key to a human-readable value
    if (newData.status) {
      summaryData.status = mapPaymentStatusToString(newData.status);
    }
    if (newData.expertId && newData.expertId.length) {
      const experts = newData.expertId.map((expert) => expert.name).join(',');
      summaryData.expertId = experts; // Display comma-separated expert names
    }
    if (newData.startDate) {
      summaryData.startDate = newData.startDate;
    }
    if (newData.endDate) {
      summaryData.endDate = newData.endDate;
    }
    // Add all filter criteria to summaryData
    setFilterSummaryData(summaryData);

    let tempFilterQuery = [];
    Object.keys(newData).forEach((key) => {
      const filterVal = newData[key];
      let value;
      if (key == 'expertId' && filterVal) {
        value = filterVal.map((expert) => expert.value).join(',');
      } else {
        value = newData[key];
      }
      if (value?.toString() || (value instanceof Date && !isNaN(value))) {
        tempFilterQuery.push(`&${key}=${value}`);
      }
    });

    const query = tempFilterQuery.join('');
    setFilterQuery(query);
    handlePagination(1, recordsPerPage, query);
  }, [filterCriteria, recordsPerPage]);

  /* REMOVE FILTER HANDLER */
  const removeFilterHandler = useCallback(
    (key) => {
      if (key == 'expertId') {
        setSelectedExperts([]);
      }

      const newData = { ...filterCriteria };
      delete newData[key];
      setFilterCriteria(newData);

      let summaryData = {};
      // Map each key to a human-readable value
      if (newData.status) {
        summaryData.status = mapPaymentStatusToString(newData.status);
      }
      if (newData.expertId && newData.expertId.length) {
        const experts = newData.expertId.map((expert) => expert.name).join(',');
        summaryData.expertId = experts; // Display comma-separated expert names
      }
      if (newData.startDate) {
        summaryData.startDate = newData.startDate;
      }
      if (newData.endDate) {
        summaryData.endDate = newData.endDate;
      }
      // Add all filter criteria to summaryData
      setFilterSummaryData(summaryData);

      let tempFilterQuery = [];
      Object.keys(newData).forEach(function (key) {
        const filterVal = newData[key];
        let value;
        if (key == 'expertId' && filterVal) {
          value = filterVal.map((expert) => expert.value).join(',');
        } else {
          value = newData[key];
        }
        if (value?.toString() || (value instanceof Date && !isNaN(value))) {
          tempFilterQuery.push(`&${key}=${value}`);
        }
      });
      let query = tempFilterQuery.join('');
      setFilterQuery(query);
      handlePagination(1, recordsPerPage, query);
    },
    [filterCriteria, recordsPerPage]
  );

  /* RESET HANDLER */
  const resetHandler = () => {
    setFilterCriteria({
      status: '',
      expertId: '',
      startDate: '',
      endDate: ''
    });
    setFilterSummaryData({
      status: '',
      expertId: '',
      startDate: '',
      endDate: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, recordsPerPage, '');
  };

  useEffect(() => {
    handlePagination(currentPage, recordsPerPage, filterQuery, selectedStatus);
  }, [currentPage, recordsPerPage, selectedStatus]);

  /* HANDLE EDIT ROW */
  const handleEditRow = (rowId) => {
    setEditingAmount((prev) => {
      // Reset the previous row value if it was changed but not saved
      if (editingRowId !== null && prev[editingRowId] !== originalAmounts[editingRowId]) {
        return { ...prev, [editingRowId]: originalAmounts[editingRowId] };
      }
      return prev;
    });

    setEditingRowId(rowId);
  };

  /* HANDLE INPUT CHANGE */
  const handleInputChange = (event, rowId) => {
    let value = event.target.value;
    if (value < 0) return; // Prevent negative values

    setEditingAmount((prev) => ({
      ...prev,
      [rowId]: value
    }));
  };

  /* VIEW REASON */
  const handleViewReason = (rowData) => {
    setOpenViewReasonPopup(true);
    setManageRequestData(rowData);
  };

  /* HANDLE PAYMENT AS PAID */
  const handleMarkPaymentAsPaid = async (rowId) => {
    const payload = {
      id: rowId,
      status: 1
    };
    setPayload(payload);
    setOpenPaymentApproveModal(true);
  };

  /* HANDLE PAYMENT APPROVE */
  const handlePaymentApprove = (payoutData) => {
    const reqBody = {
      ...payload,
      file: payoutData?.file?.type,
      paidAmount: payoutData?.paidAmount,
      invoice_number: payoutData?.invoice_number,
      notes: payoutData?.notes
    };
    setIsLoadingUpdate(true);
    Api.updatePayoutStatus(reqBody)
      .then(async (response) => {
        if (response?.data?.meta?.code === 1) {
          const meta = response?.data?.meta;
          if (meta?.filename && meta?.uploadURL) {
            const uploadImageResponse = await uploadImage(
              payoutData?.file,
              meta?.uploadURL,
              meta?.filename
            );
            if (uploadImageResponse?.status === 200) {
              setIsLoadingUpdate(false);
              successToast(pageData.imageUploadedSuccessfullyMessage);
            }
          } else {
            setIsLoadingUpdate(false);
          }
          successToast(response?.data?.meta?.message);
          setOpenPaymentApproveModal(false);
          handlePagination(currentPage, recordsPerPage, filterQuery);
        } else {
          errorToast(response?.data?.meta?.message);
        }
      })
      .catch((error) => {
        setIsLoadingUpdate(false);
        errorToast(error);
      });
  };

  /* COLUMNS */
  const columns = useMemo(
    () => [
      {
        accessorKey: 'expert_name',
        header: pageData.tableHeaderText.name,
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-[15px] leading-[18px] font-normal capitalize text-black dark:text-white">
                {row?.original?.expert_name}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false
      },
      {
        accessorKey: 'invoice_number',
        header: pageData.tableHeaderText.invoiceID,
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-sm leading-[18px] font-normal capitalize text-black dark:text-white">
                {row?.original?.invoice_number ? 'INV-' + row?.original?.invoice_number : '-'}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false
      },
      {
        accessorKey: 'invoice_date',
        header: pageData.tableHeaderText.dateReceived,
        cell: ({ row }) => (
          <div className="text-[15px] leading-[18px] font-normal whitespace-nowrap text-black dark:text-white">
            {row.original.invoice_date && moment(row.original.invoice_date).format('DD MMM YYYY')}
          </div>
        )
      },
      {
        accessorKey: 'amount',
        header: pageData.tableHeaderText.amount,
        cell: ({ row }) => (
          <div className="text-[15px] leading-[18px] font-normal text-black dark:text-white">
            {formatAmountWithCurrency(row.original.amount)}
          </div>
        )
      },
      {
        accessorKey: 'email',
        header: pageData.tableHeaderText.email,
        cell: ({ row }) => (
          <div className="text-[15px] leading-[18px] font-normal text-black dark:text-white">
            {row?.original?.expert_email}
          </div>
        )
      },
      {
        accessorKey: 'status',
        header: pageData.tableHeaderText.status,
        cell: ({ row }) => {
          const status = row?.original?.status;

          let actionStyle;
          if (status === 1) {
            actionStyle = 'bg-[#DDF2BF] border-[#438038] text-[#438038]';
          } else if (status === 2) {
            actionStyle = 'bg-[#F9EBE9] border-[#991B1B] text-[#991B1B]';
          }

          return (
            <div
              className={`px-6 py-1 text-xs inline-block capitalize rounded-full border text-center ${actionStyle}`}
            >
              {getPaymentStatus(status)}
            </div>
          );
        }
      },
      {
        id: pageData.tableHeaderText.action,
        header: 'Action',
        enableHiding: false,
        cell: ({ row }) => {
          const rowId = row.original._id;

          return (
            <div className="max-w-[100px] relative">
              <CommonPopover
                label={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                    />
                  </svg>
                }
                className="bg-transparent rounded-full p-1 border border-transparent"
                contentClassName="!p-1"
                anchor={{ to: 'bottom start', gap: '4px' }}
              >
                <ul className={`text-base p-4 space-y-2`}>
                  <li>
                    {/* REPLACE ID WITH INVOICE ID */}
                    <Link to={`/peap-management/invoice/` + rowId}>
                      {pageData.tableHeaderText.viewInvoiceBtnText}
                    </Link>
                  </li>
                </ul>
              </CommonPopover>
            </div>
          );
        }
      }
    ],
    [editingRowId, editingAmount, paymentList]
  );

  /* USE EFFECT */
  useEffect(() => {
    if (editingRowId && inputRef.current[editingRowId]) {
      inputRef.current[editingRowId].focus();
    }
  }, [editingRowId, editingAmount]);

  /* FETCH LIST OF EXPERTS */
  const fetchExpertList = async () => {
    try {
      Api.getPayoutExpertList(searchTerm).then((response) => {
        const responseData = response?.data || {};
        if (responseData?.meta?.code === 1) {
          const expertDataFromApi = responseData.data || [];
          const userOptionData = expertDataFromApi.map((expert) => ({
            value: expert?._id,
            name: `${expert?.user?.first_name} ${expert?.user?.last_name}`
          }));
          setExpertOptions(userOptionData);
        }
      });
    } catch (error) {
      console.error('Error fetching expert list:', error);
    }
  };

  /* USE EFFECT */
  useEffect(() => {
    fetchExpertList();
  }, [searchTerm]);

  /* USE EFFECT */
  useEffect(() => {
    console.log('ddfilterSummaryData', filterSummaryData);
  }, [filterSummaryData]);

  console.log('Payment list: ', paymentList);

  return (
    <>
      <div>
        {loader && <Loader />}

        {/* STATISTICS CARD */}
        <div className="mt-5">
          <div className="grid grid-cols-4 gap-5">
            {/* SUBMITTED INVOICES */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../../assets/images/new-icons/submitted-invoices.png')}
                title={pageData.submittedInvoiceText}
                value={totalInvoicesCount}
              />
            </div>
            {/* TOTAL AMOUNT PAID - NOT DYNAMIC */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../../assets/images/new-icons/amount-paid.png')}
                title={pageData.totalAmountPaidText}
                value={`£` + totalAmountPaid || 0}
              />
            </div>
            {/* TOTAL PAID INVOICES - NOT DYNAMIC */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../../assets/images/new-icons/paid-invoices.png')}
                title={pageData.totalPaidInvoicesText}
                value={totalPaidInvoicesCount}
              />
            </div>
            {/* OVERDUE INVOICES - NOT DYNAMIC */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../../assets/images/new-icons/overdue-invoices.png')}
                title={pageData.overdueInvoicesText}
                value={totalUnpaidInvoicesCount}
              />
            </div>
          </div>
        </div>

        {/* TABLE CARD */}
        <div className="mt-5">
          <div className="bg-white dark:bg-shoorah-darkBgTabColor border border-[#E7E8EA] dark:border-transparent rounded-lg">
            <div className="p-5">
              {/* TABS */}
              <div className="flex items-center gap-3">
                {/* ALL INVOICES */}
                <Button
                  onClick={() => {
                    setSelectedTab('All');
                    setSelectedStatus(null);
                  }}
                  className={`flex items-center gap-2 text-sm font-normal text-black dark:text-white border ${
                    selectedTab === 'All'
                      ? 'border-black dark:border-white'
                      : 'border-[#E7E8EA] dark:border-white/40'
                  } px-4 py-2 rounded-full`}
                >
                  {pageData.allInvoicesChipLabel}
                  <span className="px-3 py-1 text-xs font-medium bg-[#F1F1F1] rounded-full text-shoorah-primary">
                    {totalInvoicesCount}
                  </span>
                </Button>

                {/* PAID INVOICES - NOT DYNAMIC */}
                <Button
                  onClick={() => {
                    setSelectedTab('Paid');
                    setSelectedStatus(1);
                  }}
                  className={`flex items-center gap-2 text-sm font-normal text-black dark:text-white border ${
                    selectedTab === 'Paid'
                      ? 'border-black dark:border-white'
                      : 'border-[#E7E8EA] dark:border-white/40'
                  } px-4 py-2 rounded-full`}
                >
                  {pageData.paidChipLabel}
                  <span className="px-3 py-1 text-xs font-medium bg-[#DDF2BF] rounded-full text-[#438038]">
                    {totalPaidInvoicesCount}
                  </span>
                </Button>

                {/* PENDING INVOICES - NOT DYNAMIC */}
                <Button
                  onClick={() => {
                    setSelectedTab('Pending');
                    setSelectedStatus(2);
                  }}
                  className={`flex items-center gap-2 text-sm font-normal text-black dark:text-white border ${
                    selectedTab === 'Pending'
                      ? 'border-black dark:border-white'
                      : 'border-[#E7E8EA] dark:border-white/40'
                  } px-4 py-2 rounded-full`}
                >
                  {pageData.pendingChipLabel}
                  <span className="px-3 py-1 text-xs font-medium bg-[#FFFDD2] rounded-full text-[#CCB014]">
                    {totalUnpaidInvoicesCount}
                  </span>
                </Button>
              </div>

              {/* TABLE */}
              <div className="mt-5">
                <CommonTable data={paymentList || []} columns={columns} />
                <div>
                  {totalCount > recordsPerPage ? (
                    <Pagination
                      currentPage={currentPage}
                      totalCount={totalCount}
                      pageSize={recordsPerPage}
                      onPageChange={(page) => handlePagination(page, recordsPerPage, filterQuery)}
                    />
                  ) : (
                    <span />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ApprovePaymentPopup
          open={openPaymentApproveModal}
          onClose={() => setOpenPaymentApproveModal(false)}
          onSubmit={handlePaymentApprove}
          isLoadingUpdate={isLoadingUpdate}
        />
      </div>
    </>
  );
}

export default Payment;
